module.exports = __webpack_public_path__ + "static/media/quote.f8aecea0.svg";